export type TransferFlags = {
    /** Text JSON frames. Default on. Ignored if bytes or encrypt is on. */
    json?: boolean;
    /** Binary WS frames: compact tagged payload (smaller than JSON). */
    bytes?: boolean;
    /** AES-256-GCM. Implies binary frames. Needs transferSecret. */
    encrypt?: boolean;
};

export type TransferMode = "json" | "bytes" | "encrypt";

export type NormalizedTransfer = {
    mode: TransferMode;
    json: boolean;
    bytes: boolean;
    encrypt: boolean;
};

function fromBooleans(
    _json: boolean,
    bytes: boolean,
    encrypt: boolean
): NormalizedTransfer {
    let mode: TransferMode = "json";
    if (encrypt) {
        mode = "encrypt";
    } else if (bytes) {
        mode = "bytes";
    }

    return {
        mode,
        json: mode === "json",
        bytes: mode === "bytes",
        encrypt: mode === "encrypt",
    };
}

/**
 * Independent on/off flags. encrypt > bytes > json for the actual wire format.
 * Приоритет: encrypt важнее bytes, bytes важнее json.
 */
export function normalizeTransferFlags(
    flags?: TransferFlags | TransferMode | null
): NormalizedTransfer {
    if (flags === "json" || flags === "bytes" || flags === "encrypt") {
        return fromBooleans(
            flags === "json",
            flags === "bytes",
            flags === "encrypt"
        );
    }

    return fromBooleans(
        flags?.json !== false,
        Boolean(flags?.bytes),
        Boolean(flags?.encrypt)
    );
}

export const TRANSFER_HEADER_JSON = 0;
export const TRANSFER_HEADER_BYTES = 1;
export const TRANSFER_HEADER_ENCRYPT = 2;
